/* eslint-disable */
const formatDate = (dateString: string | undefined) => {
    if (dateString){
        const date = new Date(dateString)
        const options: object = { year: 'numeric', month: 'short', day: 'numeric' };

        return date.toLocaleDateString('en-US', options);
    } else {
        return dateString
    }
}

export default formatDate
